import pageStyle from "./index.module.less";
import Creator from "@/components/ticket/creator";
import Type from "../components/type";
import Vip from "../components/vip";
import Svip from "../components/svip";
import ChannelSelect from "@/components/channelSelect/index";
import Result from "../components/result";
import Status from "../components/status";
import ACEStatus from "../components/aceStatus";
import { Simple as Agent } from "../components/agent";
import SelectInput from "../components/select_input";
import Distribution from "../components/distribution";
import { getNum, setTime } from "../util";
import * as service from "../service";
import Detail from "@/components/ticket/detail";
import LangSelect from "@/components/langSelect";
import checkAuth from "@/lib/auth";

export default {
    name: "TicketAll",
    data() {
        return {
            pageStyle,
            detail: undefined,
            centerDialogVisible: false,
            selectAll: false,
            loading: false,
            searchQuery: {
                //全部工单，页面级参数，不修改
                action: "all",
                language: "",
                type_id: undefined,
                status: undefined,
                ace_status: undefined,
                channels: undefined,
                agent_id: undefined,
                time: setTime(),
                search: {
                    type: undefined,
                    inputValue: undefined
                },
                result: undefined,
                vip_level: [],
                svip_level: []
            },
            page: {
                currentPage: 1,
                pageSize: 10
            },
            totalCount: 0,
            tableData: [],
            disabledAllDistribution: false,
            selectData: [],
            initialTotal: 0
        };
    },

    components: { Creator, SelectInput, Type, ChannelSelect, Result, Status, Agent, Distribution, Detail, Vip, Svip, LangSelect, ACEStatus },

    computed: {
        allNumber() {
            return getNum("all");
        },
        showExport() {
            return checkAuth("ticket.all.export");
        }
    },
    watch: {
        "$i18n.locale"() {
            this.getListData();
        },
        searchQuery: {
            handler() {
                this.page.currentPage = 1;
                this.getListData();
            },
            deep: true
        },
        page: {
            handler() {
                this.getListData();
            },
            deep: true
        }
    },

    created() {
        this.getListData(true);
    },
    methods: {
        channelSelect(data) {
            this.searchQuery.channels = data;
        },
        getQuery(needExport) {
            let { search = {}, time, ...query } = this.searchQuery;
            if (search.type) {
                const { type, value } = search;
                query[type] = value;
            }
            if (time && time.length) {
                query.create_start_time = time[0];
                query.create_end_time = time[1];
            }

            if (needExport) {
                return {
                    ...query
                };
            }
            return {
                ...query,
                ...this.page
            };
        },
        async getListData(firstGet) {
            this.loading = true;
            const query = this.getQuery();
            const result = await service.list(query);
            const { list, pagination } = result;
            this.handleSelectAll(false);
            this.tableData = list;
            this.totalCount = pagination.totalCount;
            this.loading = false;

            if (firstGet) {
                this.initialTotal = pagination.totalCount;
            }
        },
        handleSelectionAllChange(value) {
            if (value.length == this.tableData.length) {
                this.selectAll = true;
            } else {
                this.selectAll = false;
            }

            if (value.length == 0) {
                this.disabledAllDistribution = true;
            } else {
                this.disabledAllDistribution = false;
            }

            this.selectData = value.map(value => {
                return value.id;
            });
        },
        handleSelectAll(value) {
            if (value) {
                this.$refs.multipleTable.toggleAllSelection();
            } else {
                this.$refs.multipleTable.clearSelection();
                this.disabledAllDistribution = true;
            }
        },
        async getExport() {
            const query = this.getQuery(1);
            const { download } = await service.list({ ...query, export: 1, pageSize: this.totalCount, etc: -(new Date().getTimezoneOffset() / 60) });
            window.open(download);
        },
        showDetail(data) {
            this.detail = data;
            this.centerDialogVisible = true;
        }
    }
};
